// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__1pgng","validationTips":"StatementDescriptor_validationTips__2vQk6"};